/* ============================================================
   Make React available as a global BEFORE the design modules run.

   The Wido Ops design modules (auth.js, dashboard.js, app.js, …) are a
   faithful copy of the Claude Design handoff. They are authored as IIFEs
   that read a bare `React` global and attach their exports to `window`
   (e.g. `window.WidoApp`, `window.Dashboard`). This module — imported
   first in main.js — puts React/ReactDOM on `window` so those modules
   resolve `React` at evaluation time, exactly as they did under the
   original CDN <script> setup.

   When you later refactor a module into idiomatic ESM, add
   `import React from "react"` to it and drop its reliance on this shim.
   ============================================================ */
import React from "react";
import * as ReactDOMClient from "react-dom/client";

window.React = React;
window.ReactDOMClient = ReactDOMClient;
